import { Token } from "@/core/models/abstractions/token.model";

export abstract class TokenRepository<TSubject, TToken extends Token<TSubject>> {
    public abstract get(): GetTokenResponse<TSubject, TToken>;
    public abstract delete(command: DeleteTokenCommand) : void;
}

export class GetTokenResponse<TSubject, TToken extends Token<TSubject>> {
    public token: TToken;
}

export class DeleteTokenCommand {
}

export class DeleteTokenResponse {

}